import "../styles/tailwind.css";

import Head from "next/head";
import { DefaultSeo } from "next-seo";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import CookieConsent from "@/components/cookie-consent";
import Background from "@/components/background";

// Check that PostHog is client-side (used to handle Next.js SSR)
if (
  typeof window !== "undefined" &&
  process.env.NEXT_PUBLIC_POSTHOG_KEY &&
  process.env.NEXT_PUBLIC_POSTHOG_HOST
) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    ui_host: 'https://us.posthog.com',
    // Enable debug mode in development
    loaded: (posthog) => {
      if (process.env.NODE_ENV === "development") posthog.debug();
    },
  });
}

function PartbotWebsite({ Component, pageProps, router }) {
  useEffect(() => {
    // Track page views
    const handleRouteChange = () => posthog?.capture("$pageview");

    // Only set up router events if router and events are available
    if (router?.events) {
      router.events.on("routeChangeComplete", handleRouteChange);

      return () => {
        router.events.off("routeChangeComplete", handleRouteChange);
      };
    }
  }, [router]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
      </Head>
      <DefaultSeo
        openGraph={{
          type: "website",
          locale: "en_US",
          url: "https://use.partbot.io",
          site_name: "Partbot",
        }}
        twitter={{
          handle: "@partbot",
          site: "@site",
          cardType: "summary_large_image",
        }}
      />
      <PostHogProvider client={posthog}>
        <div className="relative min-h-screen overflow-x-clip bg-stone-950">
          <Background />
          <div className="relative z-10">
            {process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ? (
              <GoogleReCaptchaProvider
                reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                scriptProps={{
                  async: false,
                  defer: false,
                  appendTo: "head",
                  nonce: undefined,
                }}
              >
                <Component {...pageProps} key={router.route} />
                <CookieConsent />
              </GoogleReCaptchaProvider>
            ) : (
              <>
                <Component {...pageProps} key={router.route} />
                <CookieConsent />
              </>
            )}
          </div>
        </div>
      </PostHogProvider>
    </>
  );
}

export default PartbotWebsite;
